import './capitalize-first-letter.css'

type Props = {
  children: string
}

export const CapitalizeFirstLetter = (props: Props) => {
  return <span className='capitalize'>{props.children}</span>
}
